var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-btn',{staticClass:"mt-4",attrs:{"color":"info","id":"helpDeskButton","href":"https://geosparkio.atlassian.net/servicedesk/customer/portal/9","target":"_blank"},on:{"click":_vm.storeMetric}},[_vm._v("Support Desk ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }